import { Benefit } from './benefits/benefit';

export class Benefits {
    constructor() {
        this.benefits = [];
        this.benefitsElements = document.querySelectorAll('.benefitBox');
        this.benefitFilter = document.querySelector('#benefitFilter');

        this.initService();
    };

    initService() {
        if (this.benefitsElements) {
            this.benefitsElements.forEach(element => {
                this.benefits.push(new Benefit(element));
            });
        }

        if (this.benefitFilter) {
            this.benefitFilter.addEventListener('change', event => {
                if (event.currentTarget.value != 0) {
                    OVS.app.helper.hide('.benefit');
                    OVS.app.helper.show('.benefit-' + event.currentTarget.value);
                } else {
                    OVS.app.helper.show('.benefit');
                }
            });
        }
    };
};
